import React from 'react';
import { googleLogout } from '@react-oauth/google';
import { useDispatch } from 'react-redux';
import { signOut } from '../../../lib/redux/sheets/slice';

export function SignOutButton() {
  const dispatch = useDispatch();
  
  const handleSignOut = () => {
    googleLogout();
    signOut(dispatch);
  };

  return (
    <button onClick={handleSignOut} className="text-xs text-gray-500 hover:text-gray-700 underline">
      Sign out
    </button>
  );
} 